import React from 'react';
import PropTypes from 'prop-types';

const FileArchiverError = ({ onClick }) => <React.Fragment>
  Something went wrong - try again by <a className="clickable" onClick={onClick}>clicking here</a>.
</React.Fragment>;

FileArchiverError.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default FileArchiverError;
